import { inject } from 'inversify';
import { APP_TIMEZONE } from '../../config/timezone';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';

export interface ICalendarExportService {
  exportTemperatureCalendarPdf(from: string, to: string): Promise<Blob>;
  exportOilCalendarPdf(from: string, to: string): Promise<Blob>;
  exportCleaningCalendarPdf(from: string, to: string): Promise<Blob>;
  exportPestControlCalendarPdf(from: string, to: string): Promise<Blob>;
  exportBlastChillingCalendarPdf(from: string, to: string): Promise<Blob>;
  exportCookingTemperatureCalendarPdf(from: string, to: string): Promise<Blob>;
  exportMetalDetectionCalendarPdf(from: string, to: string): Promise<Blob>;
  exportAuditZip(from: string, to: string): Promise<Blob>;
}

@Injectable()
export class CalendarExportService implements ICalendarExportService {
  constructor(
    @inject(HttpService)
    private readonly http: IHttpService,
  ) {}

  async exportTemperatureCalendarPdf(from: string, to: string): Promise<Blob> {
    const tz = encodeURIComponent(APP_TIMEZONE);
    const response = await this.http.getBlob(
      `calendar-export/temperature?from=${from}&to=${to}&tz=${tz}`,
    );
    return response.blob();
  }

  async exportOilCalendarPdf(from: string, to: string): Promise<Blob> {
    const response = await this.http.getBlob(`calendar-export/oil?from=${from}&to=${to}`);
    return response.blob();
  }

  async exportCleaningCalendarPdf(from: string, to: string): Promise<Blob> {
    const response = await this.http.getBlob(`calendar-export/cleaning?from=${from}&to=${to}`);
    return response.blob();
  }

  async exportPestControlCalendarPdf(from: string, to: string): Promise<Blob> {
    const response = await this.http.getBlob(`calendar-export/pest-control?from=${from}&to=${to}`);
    return response.blob();
  }

  async exportBlastChillingCalendarPdf(from: string, to: string): Promise<Blob> {
    const tz = encodeURIComponent(APP_TIMEZONE);
    const response = await this.http.getBlob(
      `calendar-export/blast-chilling?from=${from}&to=${to}&tz=${tz}`,
    );
    return response.blob();
  }

  async exportCookingTemperatureCalendarPdf(from: string, to: string): Promise<Blob> {
    const tz = encodeURIComponent(APP_TIMEZONE);
    const response = await this.http.getBlob(
      `calendar-export/cooking-temperature?from=${from}&to=${to}&tz=${tz}`,
    );
    return response.blob();
  }

  async exportMetalDetectionCalendarPdf(from: string, to: string): Promise<Blob> {
    const tz = encodeURIComponent(APP_TIMEZONE);
    const response = await this.http.getBlob(
      `calendar-export/metal-detection?from=${from}&to=${to}&tz=${tz}`,
    );
    return response.blob();
  }

  async exportAuditZip(from: string, to: string): Promise<Blob> {
    const tz = encodeURIComponent(APP_TIMEZONE);
    const response = await this.http.getBlob(
      `calendar-export/audit-zip?from=${from}&to=${to}&tz=${tz}`,
    );
    return response.blob();
  }
}
